import React, {Component, ReactElement, ReactNode} from 'react'
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material'
import {
    ConditionButtonCell,
    ConditionCategoryCell,
    ConditionInputCellForColgroup,
    ConditionTableBody,
    ConditionTableFixed,
    ConditionTableRow,
} from '../../../../styledComponents/adminPage/ConditionTable'
import PPTextField from '../../../../components/shared/forms/PPTextField'
import {AdminDefaultMediumButton, AdminPrimaryButton} from '../../../../styledComponents/adminPage/Buttons'
import {
    CondominiumInfo,
    NatGetCondominiumList,
    SearchCondition,
    SearchConditionPageInfo,
    SearchResult,
} from '../../condominium/repository/NatGetCondominiumList'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../../components/shared/hoc/withAdminPageTemplate'
import {BackLink} from '../../../../styledComponents/adminPage/Links'
import {Messages} from '../../../../Messages'
import {SortOrder} from '../../../../components/shared/SortOrder'
import {Nullable} from '../../../../app/TypeHelpers'
import {formatDateTimeForUpdateDate} from '../../../../formatters/formatDate'
import {PREFECTURES_MASTER, VALID_OR_NOT_CHECK} from '../../../../CodeMaster'
import NatCondominiumRepo from '../../condominium/repository/NatCondominiumRepo'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import styled from 'styled-components'
import {AdminPageHeadingArea} from '../../../../components/shared/pageBaseComponents/AdminPageHeadingArea'
import {AsyncCommunicationProps} from '../../../../components/shared/hoc/withAsyncCommunication'
import NatCondominiumGroupRepo from '../../condominiumGroup/repository/NatCondominiumGroupRepo'
import ListSearchFormArea from '../../../../styledComponents/adminPage/ListSearchFormArea'
import {addEmptyData, NoSelectedValue} from '../../../../componentHelper/selectHelper'
import PPSelect from '../../../../components/shared/forms/PPSelect'
import {SelectChangeEvent} from '@mui/material/Select'
import {Location, NavigateFunction} from 'react-router-dom'

interface Props {
    condominiumRepo: NatCondominiumRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    closeSelectDeliveryTargetAreaDiaLog: () => void
    setSelectedCondominiumInfo?: (selectedCondominiumInfo: CondominiumInfo) => void
    setSelectedDeliveryTargetCondominiumInfo?: (selectedExclusionCondominiumInfo: CondominiumInfo[]) => void
    selectedCondominiumGroupId?: number | null
    setDeliveryTargetPrefectureCd?: (deliveryTargetPrefectureCd: string) => void
    setDeliveryTargetAddress2?: (deliveryTargetAddress2: string) => void
    eventEmitter: EventEmitterExAdmin
    navigate: NavigateFunction
    location: Location
}

interface States {
    isLoadCompleted: boolean
    searchCondition: SearchCondition
    condominiums: CondominiumInfo[]
    searchConditionPageInfo: SearchConditionPageInfo
    searchConditionSortInfo: SortOrder[]
    searchResult: SearchResult
    clickSearchButton: boolean
    noSearchConditionFlag: boolean
}

export default class NatCondominiumSelectionComponent extends Component<Props & AsyncCommunicationProps, States> {


    constructor(props: Props & AsyncCommunicationProps) {
        super(props)

        this.state = {
            isLoadCompleted: false,
            condominiums: [],
            searchCondition: {
                ['condominiumGroupId']: this.props.selectedCondominiumGroupId ?
                    this.props.selectedCondominiumGroupId : null,
                ['condominiumCd']: '',
                ['condominiumName']: '',
                ['prefectureCd']: '',
                ['address2']: '',
                ['detailSearchCondition']: null,
                ['billingStatus']: {
                    billingDeadline: null,
                    confirmStatus: null,
                    targetYearMonth: null,
                    electedTargetYearMonth: null,
                },
                ['unreleaseCondominiumExclusionFlg']: null,
            },
            searchConditionPageInfo: {
                ['pageNum']: 0,
                ['page']: 0,
            },
            searchConditionSortInfo: [
                new SortOrder('condominiumCd', 'asc'),
            ],
            searchResult: {
                ['total']: 0,
                ['totalPage']: 0,
                ['start']: 0,
                ['end']: 0,
            },
            clickSearchButton: false,
            noSearchConditionFlag: false,
        }

        this.onChangePrefectureCd = this.onChangePrefectureCd.bind(this)
        this.onChangeAddress2 = this.onChangeAddress2.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.updateSelectedDeliveryTargetInfo = this.updateSelectedDeliveryTargetInfo.bind(this)

    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        this.props.eventEmitter.closeLoading()
        this.setState({isLoadCompleted: true})
    }

    onChangePrefectureCd(event: SelectChangeEvent<unknown>): void {
        const searchConditions = this.state.searchCondition
        if (event.target.value === NoSelectedValue) {
            searchConditions.prefectureCd = ''
        } else {
            const codeMaster = PREFECTURES_MASTER.codeToEnumConstants(event.target.value as string)
            if (codeMaster) {
                searchConditions.prefectureCd = event.target.value as string
            } else {
                searchConditions.prefectureCd = ''
            }
        }
        this.setState({searchCondition: searchConditions})
    }

    onChangeAddress2(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchConditions = this.state.searchCondition
        searchConditions.address2 = event.target.value
        this.setState({searchCondition: searchConditions})
    }

    renderCondominiumTable(condominiums: CondominiumInfo[]): Nullable<ReactElement> {
        if (condominiums.length === 0) {
            return null
        }

        return (
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell key={'condominiumCd'} align={'center'}>物件コード</TableCell>
                        <TableCell key={'condominiumName'} align={'center'}>物件名</TableCell>
                        <TableCell key={'condominiumGroupName'} align={'center'}>物件グループ</TableCell>
                        <TableCell key={'prefecture'} align={'center'}>都道府県</TableCell>
                        <TableCell key={'address2'} align={'center'}>市区町村</TableCell>
                        <TableCell key={'status'} align={'center'}>非公開</TableCell>
                        <TableCell key={'updateDatetime'} align={'center'}>更新日時</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.condominiums.map(
                        condominium => this.renderCondominiumRecord(condominium),
                    )}
                </TableBody>
            </Table>
        )
    }

    updateSelectedDeliveryTargetInfo(): void {
        if (this.props.setSelectedDeliveryTargetCondominiumInfo) {
            this.props.setSelectedDeliveryTargetCondominiumInfo(this.state.condominiums)
        }
        if (this.props.setDeliveryTargetPrefectureCd && this.state.searchCondition.prefectureCd !== null) {
            this.props.setDeliveryTargetPrefectureCd(this.state.searchCondition.prefectureCd)
        }
        if (this.props.setDeliveryTargetAddress2 && this.state.searchCondition.address2 !== null) {
            this.props.setDeliveryTargetAddress2(this.state.searchCondition.address2)
        }
    }

    renderCondominiumRecord(condominium: CondominiumInfo): ReactNode {
        return (
            <TableRow>
                <TableCell align={'left'}>{condominium.condominiumCd}</TableCell>
                <TableCell align={'left'}>{condominium.condominiumName}</TableCell>
                <TableCell align={'right'}>{condominium.condominiumGroupName}</TableCell>
                <TableCell align={'center'}>{this.setPrefectureName(condominium.prefectureCd)}</TableCell>
                <TableCell align={'center'}>{condominium.address2}</TableCell>
                <TableCell align={'center'}>{this.setReleaseText(condominium.releaseFlg)}</TableCell>
                <TableCell align={'center'}>{formatDateTimeForUpdateDate(condominium.updateDatetime)}</TableCell>
            </TableRow>
        )
    }

    setReleaseText(releaseFlg: string): string {
        const validOrNotCheck = VALID_OR_NOT_CHECK.codeToEnumConstants(releaseFlg)
        if (validOrNotCheck) {
            return validOrNotCheck.label
        } else {
            return ''
        }
    }

    setPrefectureName(prefectureCd: string): string {
        const prefecturesMaster = PREFECTURES_MASTER.codeToEnumConstants(prefectureCd)
        if (prefecturesMaster) {
            return prefecturesMaster.label
        } else {
            return ''
        }
    }

    async onClickSearchButton(): Promise<void> {
        if (this.state.searchCondition.prefectureCd === '' && this.state.searchCondition.address2 === '') {
            const searchResult: SearchResult = {
                total: 0,
                totalPage: 0,
                start: 0,
                end: 0,
            }
            this.setState({
                clickSearchButton: true,
                condominiums: [],
                searchResult: searchResult,
                noSearchConditionFlag: true,
            })
        } else {
            await this.searchCondominiums(
                this.state.searchCondition,
                this.state.searchConditionPageInfo,
                this.state.searchConditionSortInfo,
            )
        }
    }

    // 物件検索
    async searchCondominiums(
        searchCondition: SearchCondition,
        searchConditionPageInfo: SearchConditionPageInfo,
        searchConditionSortInfo: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const searchParams: string[] = []
            if (searchConditionSortInfo) {

                searchConditionSortInfo.forEach((sortInfo) => {
                    const value: string = `${sortInfo.sortKey}:${sortInfo.sortDirection}`
                    searchParams.push(`sortInfo=${value}`)
                })
            }

            // 物件一覧取得
            const getCondominiumResponse: Nullable<NatGetCondominiumList> =
                await this.props.asyncCallFunction(
                    this.props.condominiumRepo.getCondominiumList.bind(
                        this.props.condominiumRepo,
                        {...searchCondition, ...searchConditionPageInfo, sortInfo: searchParams},
                    ),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )

            if (getCondominiumResponse) {
                if (getCondominiumResponse.details) {
                    this.setState({
                        condominiums: getCondominiumResponse.details.condominiumInfo,
                        searchResult: getCondominiumResponse.details.searchResult,
                        clickSearchButton: true,
                        noSearchConditionFlag: false,
                    })
                }

            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    render(): ReactNode {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return <>
            <Dialog
                scroll={'paper'}
                id={'pp-dialog'}
                open={true}
                transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                maxWidth={'xl'}
            >
                <StyledDialogFixed>
                    <AdminPageHeadingArea
                        title={'配信対象地域選択'}
                    />
                </StyledDialogFixed>
                <StyledDialogContent>
                    <ListSearchFormArea
                        onEnterKey={this.onClickSearchButton}
                    >
                        <ConditionTableFixed>
                            <colgroup>
                                <col width={'10%'}/>
                                <col width={'15%'}/>
                                <col width={'25%'}/>
                                <col width={'5%'}/>
                                <col width={'25%'}/>
                            </colgroup>
                            <ConditionTableBody>
                                <ConditionTableRow>
                                    <ConditionCategoryCell
                                        rowSpan={2}
                                    >住所
                                    </ConditionCategoryCell>
                                    <ConditionInputCellForColgroup>都道府県</ConditionInputCellForColgroup>
                                    <ConditionInputCellForColgroup>
                                        <PPSelect
                                            data={addEmptyData(PREFECTURES_MASTER.values(), '都道府県を選択してください')}
                                            onChange={this.onChangePrefectureCd}
                                            eventKeys={['prefectureCd']}
                                            eventEmitter={this.props.eventEmitter}
                                            value={this.state.searchCondition.prefectureCd}
                                        />
                                    </ConditionInputCellForColgroup>
                                    <ConditionInputCellForColgroup>市区町村</ConditionInputCellForColgroup>
                                    <ConditionInputCellForColgroup>
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    maxLength: 50,
                                                },
                                            }}
                                            fullWidth
                                            onChange={this.onChangeAddress2}
                                            defaultValue={this.state.searchCondition.address2}
                                        />
                                    </ConditionInputCellForColgroup>
                                    <ConditionButtonCell>
                                        <AdminDefaultMediumButton
                                            onClick={this.onClickSearchButton}>
                                            検索する
                                        </AdminDefaultMediumButton>
                                    </ConditionButtonCell>
                                </ConditionTableRow>
                            </ConditionTableBody>
                        </ConditionTableFixed>
                    </ListSearchFormArea>
                    <SearchResultTotal>
                        {this.state.clickSearchButton &&
                            <Box mt={'5px'} ml={'10px'}>
                                <Typography variant={'body2'}>
                                    {this.state.searchResult.total === 0 &&
                                        this.state.noSearchConditionFlag &&
                                        Messages.IOPCC0017.toString('検索する')
                                    }
                                    {this.state.searchResult.total === 0 &&
                                        !this.state.noSearchConditionFlag &&
                                        Messages.IOPCC0014.toString('')
                                    }
                                    {this.state.searchResult.total > 0 &&
                                        Messages.IOPCC0025.toString(this.state.searchResult.total.toString())
                                    }
                                </Typography>
                            </Box>
                        }
                    </SearchResultTotal>
                    <PageMainArea>
                        {this.renderCondominiumTable(this.state.condominiums)}
                    </PageMainArea>
                </StyledDialogContent>
                <StyledDialogActions>
                    <PageFooterArea>
                        <PageFotterAreaRight>
                            <AdminPrimaryButton
                                disabled={this.state.searchResult.total === 0}
                                onClick={this.updateSelectedDeliveryTargetInfo}
                            >
                                確定
                            </AdminPrimaryButton>
                        </PageFotterAreaRight>
                        <PageFotterAreaLeft>
                            <BackLink
                                onClick={this.props.closeSelectDeliveryTargetAreaDiaLog}
                            >
                                キャンセル
                            </BackLink>
                        </PageFotterAreaLeft>
                    </PageFooterArea>
                </StyledDialogActions>
            </Dialog>
        </>
    }
}

const StyledDialogFixed = styled(DialogTitle)`
  &.MuiDialogTitle-root {
    padding: 24px 24px 0;
    min-width: 960px;
  }
`

const StyledDialogContent = styled(DialogContent)`
  &.MuiDialogContent-root {
    padding: 0 24px 8px;
    min-width: 960px;
  }
`

const StyledDialogActions = styled(DialogActions)`
  &.MuiDialogActions-root {
    padding: 8px 24px 24px;
  }
`

const SearchResultTotal = styled.div`
  padding: 8px 12px;
`
